// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Moon_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21.894 13.334a.75.75 0 0 0-.75-.187A8.258 8.258 0 0 1 10.851 2.853a.75.75 0 0 0-.938-.938 9.83 9.83 0 0 0-4.96 3.47A9.75 9.75 0 0 0 12.75 21a9.66 9.66 0 0 0 5.861-1.957 9.83 9.83 0 0 0 3.469-4.96.75.75 0 0 0-.186-.749Zm-4.185 4.51A8.25 8.25 0 0 1 6.156 6.292a8.34 8.34 0 0 1 2.943-2.438A10 10 0 0 0 9 5.25 9.76 9.76 0 0 0 18.75 15a10 10 0 0 0 1.399-.1 8.34 8.34 0 0 1-2.44 2.944Z',
  viewBox: '0 0 24 24',
  glyph: 'Moon_Stroke2_Corner0_Rounded',
})
